import { createContext } from 'react';
import {
	IExtendedRestaurantBankSettings,
	IRestaurantBankSettingsAcquirer,
	IUpdateRestaurantBankSettings,
	TYandexPaymentType,
} from 'types';

export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'imageFileSizeExceeded'
	| 'success'
	| 'error'
	| 'errorBpaSettings';
export interface IInitialFormData {
	bankSettings: IExtendedRestaurantBankSettings[];
}

export interface IBankSettingsState {
	needRefetchData: boolean;
	initialFormData: Nullable<IInitialFormData>;
	bankSettings: IExtendedRestaurantBankSettings[];
	fetchedAcquirers: IRestaurantBankSettingsAcquirer[];
	dataForSubmit: Nullable<IUpdateRestaurantBankSettings>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const bankSettingsInitialState: IBankSettingsState = {
	needRefetchData: false,
	initialFormData: null,
	bankSettings: [],
	fetchedAcquirers: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IBankSettingsContext extends IBankSettingsState {
	refetchData(value: boolean): void;
	addBankSettingBlock(value: IExtendedRestaurantBankSettings): void;
	deleteBankSettingBlock(value: string): void;
	changePriority(settingsId: string, value: string): void;
	changeMerchantId(settingsId: string, value: string): void;
	changeMerchantName(settingsId: string, value: string): void;
	changeAcquirer(settingsId: string, value: Nullable<IRestaurantBankSettingsAcquirer>): void;
	changeSbpAccountNumber(settingsId: string, value: string): void;
	changeSbpLogin(settingsId: string, value: string): void;
	changeYandexApiKey(settingsId: string, value: string): void;
	changeYandexPaymentType(settingsId: string, value: TYandexPaymentType[]): void;
	changeVivaApiKey(settingsId: string, value: string): void;
	changeVivaApiSecret(settingsId: string, value: string): void;
	changeAccNumber(settingsId: string, value: string): void;
	changeSector(settingsId: string, value: string): void;
	changeSdRef(settingsId: string, value: string): void;
	changeYandexChequeApiToken(settingsId: string, value: string): void;
	changeYandexChequeApiPartnerId(settingsId: string, value: string): void;
	changeMerchantAccount(settingsId: string, value: string): void;
	changeStore(settingsId: string, value: string): void;
	changeXApiKey(settingsId: string, value: string): void;
	changeCheckoutUrlPrefix(settingsId: string, value: string): void;
	toggleSplitPayments3S(settingsId: string): void;
	changeMerchantBalanceAccountId(settingsId: string, value: string): void;
	changeKmBalanceAccountId(settingsId: string, value: string): void;
	toggleDisplayTips(settingsId: string): void;
	toggleIsFeeFiscalized(settingsId: string): void;
	toggleGenerateQrInstantly(settingsId: string): void;
	changePaymentTypeId(settingsId: string, value: string): void;
	changeSmsCode(settingsId: string, value: string): void;
	changeTBankPlaceId({ settingsId, value }: { settingsId: string; value: string }): void;
	changeMasterWallet({ settingsId, value }: { settingsId: string; value: string }): void;
	setBankSettingsFile(settingsId: string, value: Nullable<string>): void;
	setLogoFile(settingsId: string, value: Nullable<string>): void;
	deleteBankSettingFile(value: string): void;
	deleteLogoFile(value: string): void;
	setFetchedAcquirers(value: IRestaurantBankSettingsAcquirer[]): void;
	setDataForSubmit(value: Nullable<IUpdateRestaurantBankSettings>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const BankSettingsContext = createContext<IBankSettingsContext>({
	refetchData: () => undefined,
	addBankSettingBlock: () => undefined,
	deleteBankSettingBlock: () => undefined,
	changePriority: () => undefined,
	changeMerchantId: () => undefined,
	changeMerchantName: () => undefined,
	changeAcquirer: () => undefined,
	changeSbpAccountNumber: () => undefined,
	changeSbpLogin: () => undefined,
	changeYandexApiKey: () => undefined,
	changeYandexPaymentType: () => undefined,
	changeVivaApiKey: () => undefined,
	changeVivaApiSecret: () => undefined,
	changeAccNumber: () => undefined,
	changeSector: () => undefined,
	changeSdRef: () => undefined,
	changeYandexChequeApiToken: () => undefined,
	changeYandexChequeApiPartnerId: () => undefined,
	changeMerchantAccount: () => undefined,
	changeStore: () => undefined,
	changeXApiKey: () => undefined,
	changeCheckoutUrlPrefix: () => undefined,
	toggleSplitPayments3S: () => undefined,
	changeMerchantBalanceAccountId: () => undefined,
	changeKmBalanceAccountId: () => undefined,
	toggleDisplayTips: () => undefined,
	toggleIsFeeFiscalized: () => undefined,
	toggleGenerateQrInstantly: () => undefined,
	changePaymentTypeId: () => undefined,
	changeSmsCode: () => undefined,
	changeTBankPlaceId: () => undefined,
	changeMasterWallet: () => undefined,
	setBankSettingsFile: () => undefined,
	setLogoFile: () => undefined,
	deleteBankSettingFile: () => undefined,
	deleteLogoFile: () => undefined,
	setFetchedAcquirers: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...bankSettingsInitialState,
});
